import * as React from 'react';
import * as styled from './styled';
import Input from 'components/Input';
import ControlButton from 'components/ControlButton';
import {IconTrash} from 'icons';
import {IngredientCardProps} from './types';

/**
 * The card of an ingredient.
 * @param {IngredientCardProps} props
 * @return {React.ReactElement<IngredientCardProps>}
 * @constructor
 */
export default function IngredientCard(
    props: IngredientCardProps,
): React.ReactElement<IngredientCardProps> {
  /**
   * Render content.
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Render title.
     * @return {JSX.Element}
     */
    function renderTitle(): JSX.Element {
      return (
        <li>{props.title}</li>
      );
    }

    /**
     * Render weight.
     * @return {JSX.Element}
     */
    function renderWeight(): JSX.Element {
      /**
       * The change event handler.
       * @param {React.ChangeEvent<HTMLInputElement>} event
       */
      function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
        props.onWeightChange && (
          props.onWeightChange(Number(event.target.value))
        );
      }

      return props.weight !== undefined ? (
        <li>
          <Input
            type="number"
            min={0}
            value={props.weight}
            onChange={handleChange}
            stretched
            required
          />
        </li>
      ) : <div />;
    }

    /**
     * Render energy.
     * @return {JSX.Element}
     */
    function renderEnergy(): JSX.Element {
      return (
        <React.Fragment>
          <li>{props.energy.kcal}</li>
          <li>{props.energy.proteins}</li>
          <li>{props.energy.fats}</li>
          <li>{props.energy.ch}</li>
        </React.Fragment>
      );
    }

    return (
      <styled.Content>
        {renderTitle()}
        {renderWeight()}
        {renderEnergy()}
      </styled.Content>
    );
  }

  /**
   * Render delete control.
   * @return {JSX.Element | undefined}
   */
  function renderDelete(): JSX.Element | undefined {
    /**
     * The click event handler.
     * @return {void}
     */
    function handleClick(): void {
      props.onDelete && props.onDelete();
    }

    return props.onDelete ? (
      <ControlButton type="button" onClick={handleClick}>
        <IconTrash />
      </ControlButton>
    ) : undefined;
  }

  return (
    <styled.Wrapper>
      {renderContent()}
      {renderDelete()}
    </styled.Wrapper>
  );
}
